import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { Form, FormGroup, Modal, ModalBody, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import SvgImage from "../../../Icons/Icons";
import { DatePickerField } from "../../../core/inputs/input";
import moment from "moment";
import { Button } from "reactstrap";
import Switch from "react-switch";
import { getSignedUrlApiAction, storeMedia, toastStatus } from "../../../../services/Store/Actions/appActions";
import { saveVehicleProfileData, getVehicleProfileData } from "../../../../services/Store/Actions/fleetActions";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
function AddEditDocModal(props) {
    const dispatch = useDispatch();
    const datepickerRefRegistration = useRef();
    const datepickerRefExpiry = useRef();


    const handleClickDatepickerRegistration = () => {
        const datepickerElement = datepickerRefRegistration.current;
        // console.log("datepickerElement = ", datepickerElement);
        datepickerElement.setOpen(!datepickerElement.open);
      };
      const handleClickDatepickerExpiry = () => {
        const datepickerElement = datepickerRefExpiry.current;
        // console.log("datepickerElement = ", datepickerElement);
        datepickerElement.setOpen(!datepickerElement.open);
      };
    
    const toastObject = useSelector((state) => state?.app?.toastObject);

    const {  toggle, modal, setModal, isEdit,fleetId, type, data, value, rawImage , setRawImage} = props
    let [doc, setDoc] = useState({});
    const handleClose = () => {
        setDoc({});
        setModal(!modal);
      };
      const handleSetImage = (values) => {
        setRawImage(values?.docUrl)
    };

    const [imageLoader, setImageLoader] = useState(false);
    const [displayName, setDisplayName] = useState(false);

    const [update, setUpdate] = useState(false);
    const closeUpdate = () => {
        setUpdate(false);
    };
    const toggleUpdate = () => {
        setUpdate(!update);
    }
    const [imageModal, setImageModal] = useState(false);
    const closeImageModal = () => {
        setImageModal(false);
    };
    const toggleImageModal = () => {
        setImageModal(!imageModal);
    }
    const [uploadStatus, setUploadStatus] = useState(false);
    const closeUploadStatus = () => {
        setUploadStatus(false);
    };
    const toggleUploadDoc = () => {
        setUploadStatus(!uploadStatus);
    }
    
    const documentId = "addEditDocModal"
    const notify =  (msg, isError = false) => {
        console.log("ajshgvdkba");
        if(isError){
            toast.error(msg || "failed", {
                toastId: documentId,
            })
        }else{
            toast.success(msg || "success", {
                toastId: documentId,
            })
        }
       
    }
    return  (
        <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
        // scrollable={true}

        centered={true}
        // style={{borderRadius : "10px"}}
      >
        <ModalBody
          className="transactionModalBody"
          style={{ marginTop: "25px" }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <div
                className="closeBtnWithBackgroundForTrip"
                onClick={handleClose}
              >
                <SvgImage
                  classname="close-btn-text"
                  style={{ width: "10%", height: "10%" }}
                  name="crossBtnWIthBackground"
                  width="20%"
                  height="20%"
                />
              </div>
              <div
                className="PGCollectiontText col-3 "
                style={{ marginLeft: "50px" }}
              >
                {console.log("isEditisEditisEdit", isEdit)}
                {isEdit && isEdit != "undefined" ? (
                  <text>Edit {value}</text>
                ) : (
                  <text>Add Document</text>
                )}
                {/* <text>Create LR</text> */}
              </div>
              <hr
                style={{ marginLeft: "25px", border: "2px solid #2E7C7B" }}
              ></hr>
            </div>
            <Formik
                    // isValid='true'
                    enableReinitialize
                    initialValues={{
                        fleetId: fleetId ? fleetId : "",
                        docUrl: null,
                        tagId: data?.tagId,
                        regDate: data?.serviceDate,
                        expDate: data?.expiryDate,
                        remarks: data?.remarks,
                    }}
                    onSubmit={(values) => {
                        console.log('rererere111',values)

                        let objVal = {
                            fleetId: fleetId ? fleetId : "",
                            expenseType: type,
                            imageUrl: values?.docUrl,
                            tagId: values?.tagId,
                            remarks: values?.remarks,
                            expiryDate: values?.expDate,
                            serviceDate: values?.regDate
                        };
                        if(!isEdit) objVal.remarks = JSON.stringify({Type: values.type})
                        dispatch(
                            saveVehicleProfileData(objVal, (res) => {
                            if (res?.status == 200) {
                                console.log('rererere',res)
                                handleSetImage(values)
                                dispatch(getVehicleProfileData({fleetId: fleetId}, (res)=> {
                                    console.log("dispatchgetVehicleProfileData", res);
                                }));
                                handleClose();
                                notify("document uploaded successFully");
                            } else {
                                handleClose();
                                notify("document upload failed", true);
                            }
                        })
                        );
                    }}
                    >
                    {({
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        resetForm,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => (
                        <Form
                        onSubmit={handleSubmit}
                        style={{ padding: "0 50px 0 50px" }}
                        >
                        <div className="">
                        {!isEdit ?  
                        <FormGroup style={{paddingLeft: "25px", paddingBottom: "10px",paddingTop: "10px"}}>
                            <label for="type" className="heading3 semiBold">
                                Document Type
                            </label>
                            <div className="custNamepadd3">
                                <input
                                type="text"
                                id="type"
                                className={`inputBoxCust1 ${
                                    touched.type && errors.type ? "is-invalid" : ""
                                }`}
                                name="type"
                                value={values.type}
                                onChange={(event) => {
                                    setFieldValue("type", event.target.value, true);
                                }}
                               
                                touched={touched.type}
                                errors={errors.type}
                                placeholder="Enter Document Title"
                                autocomplete="off"
                                />
                            </div>
                        </FormGroup> : <></>}
                        <FormGroup className="divClass1" >
                            <FormGroup>
                                <label for="tagId" className="heading3 semiBold">
                                    Document No
                                </label>
                                <div className="custNamepadd3">
                                    <input
                                    type="text"
                                    id="tagId"
                                    className={`inputBoxCust1 ${
                                        touched.tagId && errors.tagId ? "is-invalid" : ""
                                    }`}
                                    name="tagId"
                                    value={values.tagId}
                                    onChange={(event) => {
                                        setFieldValue("tagId", event.target.value, true);
                                    }}
                                
                                    touched={touched.tagId}
                                    errors={errors.tagId}
                                    placeholder="Enter Document No"
                                    autocomplete="off"
                                    />
                                </div>
                            </FormGroup>
                            <FormGroup style={{ paddingRight: "170px" }}>
                            <label for="tagId" className="heading3 semiBold">
                                    Upload Documnet
                                </label>
                                <div style={{ display: "flex" }}>
                                    {!uploadStatus ? (
                                    <p
                                        className="heading4 Regular"
                                        style={{ margin: "10px 0 5px" }}
                                    >
                                        Upload Document
                                    </p>
                                    ) : (
                                    <></>
                                    )}
                                    {!uploadStatus ? (
                                    <Button
                                        className="add-attach-for-fastag-linked-vehicle-new"
                                        type="button"
                                    >
                                        {imageLoader ? (
                                        <div style={{ zIndex: 10 }}>
                                            <ClipLoader
                                            color={"#2E7C7B"}
                                            loading={true}
                                            size={20}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                        ) : (
                                        <div>
                                            <SvgImage
                                            name="AddAttachment"
                                            height="25"
                                            width="25"
                                            />
                                            <input
                                            type="file"
                                            style={{ width: "25px" }}
                                            // multiple
                                            // accept="image/*"
                                            accept="image/*"
                                            className="add-lr-attachment"
                                            onChange={(e) => {
                                                const img = e?.target.files[0];
                                                console.log("image", img?.name);

                                                const tempArray = Object.assign(
                                                [],
                                                values.docs
                                                );
                                                console.log("sel", tempArray);

                                                if (img == null) {
                                                //clear image
                                                setFieldValue("docUrl", "", true);
                                                //for now  only one supported
                                                } else {
                                                console.log("upload", {
                                                    img: img,
                                                    uploadType: "aadharFront",
                                                    isRes: true,
                                                });
                                                setImageLoader(true);
                                                dispatch(
                                                    storeMedia(
                                                    {
                                                        img: img,
                                                        uploadType: "aadharFront",
                                                        isRes: false,
                                                    },
                                                    (res) => {
                                                        setUploadStatus(true);
                                                        setDisplayName((prev) => [
                                                        { name: img?.name },
                                                        ]);
                                                        setImageLoader(false);
                                                        if (res?.url) {
                                                        console.log("opt", res);
                                                        tempArray.push(
                                                            res?.data?.Location
                                                        );
                                                        setFieldValue(
                                                            "docUrl",
                                                            res?.url,
                                                            true
                                                        );
                                                        // setFieldValue('docs', tempArray, true);
                                                        //for now  only one supported
                                                        setFieldValue(
                                                            "docs",
                                                            [res?.data?.Location],
                                                            true
                                                        );
                                                        }
                                                    }
                                                    )
                                                );
                                                }
                                            }}
                                            />
                                        </div>
                                        )}
                                        <div
                                        style={{
                                            margin: "0px -16px 2px -614px",
                                            color: "red",
                                        }}
                                        >
                                        {errors.docUrl && touched.docUrl ? (
                                            <div>*{errors.docUrl}</div>
                                        ) : null}
                                        </div>
                                    </Button>
                                    ) : (
                                    <></>
                                    )}
                                    <div className="selected-img">
                                    {uploadStatus ? (
                                        displayName?.map((d) => {
                                        return (
                                            <div className="row" style={{marginTop: "10px",marginLeft: "-40px",justifyContent:"space-between"}}>
                                            <div className="col-9">
                                                <p
                                                style={{
                                                    color: "black",
                                                    cursor: "pointer",
                                                    marginRight: "10px",
                                                }}
                                                onClick={() => {
                                                    window.open(d.link);
                                                }}
                                                >
                                                {d.name}
                                                </p>
                                            </div>
                                            <div
                                                className="col-3"
                                                onClick={() => {
                                                    setUploadStatus(false);
                                                }}
                                            >
                                                <text>Change</text>
                                            </div>
                                            </div>
                                        );
                                        })
                                    ) : (
                                        <></>
                            )}
                            </div>
                        </div>
                        </FormGroup>
                    </FormGroup>
                    <FormGroup className="divClass1">
                        <FormGroup>
                        <label for="regDate" className="heading3 semiBold">
                            Registration Date
                        </label>
                        <div
                            className="custNamepadd3 row"
                            style={{ width: "200px" }}
                        >
                            <div className="col-9">
                            <DatePickerField
                                classname="searchBar-input1"
                                name="regDate"
                                header="Select Start date"
                                value={values.regDate}
                                onChange={(v) => {
                                setFieldValue("regDate", v, true);
                                }}
                                //onChange={(v) => setFieldValue("endDate", v, true)}
                                maxDateDate={
                                values.expDate === "" ? "" : values.expDate
                                }
                                ref1={datepickerRefRegistration}
                                style={{ width: "100px" }}
                            />
                            </div>
                            <div className="col-3">
                            <label
                                className="date-input"
                                for="regDate"
                                style={{
                                position: "relative",
                                cursor: "pointer",
                                }}
                                onClick={() => {
                                    handleClickDatepickerRegistration();
                                }}
                            >
                                <SvgImage
                                name="CalenderLogo"
                                width="32"
                                height="32"
                                />
                            </label>
                            </div>
                        </div>
                        <div
                            className="heading4 Regular"
                            style={{ margin: "7px 0 0px 0", color: "red" }}
                        >
                            {errors.regDate && touched.regDate ? (
                            <div>*{errors.regDate}</div>
                            ) : null}
                        </div>
                        </FormGroup>
                        <FormGroup style={{ marginRight: "110px" }}>
                        <label for="expDate" className="heading3 semiBold">
                            Expiry Date
                        </label>
                        <div
                            className="custNamepadd3 row"
                            style={{ width: "200px" }}
                        >
                            <div className="col-9">
                            <DatePickerField
                                classname="searchBar-input1"
                                name="expDate"
                                header="Select End date"
                                value={values.expDate}
                                onChange={(v) => {
                                setFieldValue("expDate", v, true);
                                }}
                                //onChange={(v) => setFieldValue("expDate", v, true)}
                                minDate={
                                values.regDate === "" ? "" : values.regDate
                                }
                                ref1={datepickerRefExpiry}
                                style={{ width: "100px" }}
                            />
                            </div>
                            <div className="col-3">
                            <label
                                className="date-input"
                                for="expDate"
                                style={{
                                position: "relative",
                                cursor: "pointer",
                                }}
                                onClick={() => {
                                    handleClickDatepickerExpiry();
                                }}
                            >
                                <SvgImage
                                name="CalenderLogo"
                                width="32"
                                height="32"
                                />
                            </label>
                            </div>
                        </div>
                        <div
                            className="heading4 Regular"
                            style={{ margin: "7px 0 0px 0", color: "red" }}
                        >
                            {errors.expDate && touched.expDate ? (
                            <div>*{errors.expDate}</div>
                            ) : null}
                        </div>
                        </FormGroup>
                    </FormGroup> 
                    <FormGroup
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingLeft: "100px",
                        paddingRight: "100px",
                      }}
                    >
                      <Button
                        type="submit"
                        style={{ width: "70%" }}
                        className="generateOtp text3 Medium btn btn-secondary"
                      >
                        Submit
                      </Button>
                    </FormGroup>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
     
    </div>
    )
}
export default AddEditDocModal;




